import { Component, Input } from '@angular/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { AuthMethodService } from 'src/app/services/auth-method.service';
import { RootScopeService } from 'src/app/services/root-scope.service';
import * as _moment from 'moment';
import {default as _rollupMoment, Moment} from 'moment';
import { AUTHENTICATION_COMPONENT_ERR_MSG, indicativeMessages } from 'src/app/models/Constants';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { allMonths } from '../../../models/Constants';
import { GenesysCloudService } from 'src/app/services/genesys-cloud.service';
import { LogService } from 'src/app/services/log.service';
import { AaaSService } from 'src/app/services/aaas.service';
import * as Constants from '../../../models/Constants';
import { CustomMomentDateAdapter } from 'src/app/models/customMomentDateAdapter';
import { CustomerAccountBusinessLogicService } from 'src/app/services/customer-account-business-logic.service';

const moment = _rollupMoment || _moment;
export const MY_FORMATS = {
  parse: {
    dateInput: 'MMM-DD-YYYY'
  },
  display: {
    dateInput:'MMM-DD-YYYY', //MM-DD-YYYY// 'MM/DD/YYYY',//'MMM-DD-YYYY'
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'll',
    monthYearA11yLabel: 'MMM YYYY',
  },
};
@Component({
  selector: 'app-ftu-panel',
  templateUrl: './ftu-panel.component.html',
  styleUrls: ['./ftu-panel.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: CustomMomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ]
  
})
export class FTUPanelComponent {
  @Input() languages:any; //formControlName
  public alertMSG = Constants;
  selectedDateValidation: string = '';
  selectedIdentifierValidation:string="";
  selectedLocationValidation: string = '';
  public maxDate: Moment = moment();
  errorMessage:string="";hireDateMsg:string="";
  ApiFailure = AUTHENTICATION_COMPONENT_ERR_MSG.API_FAILURE_INDICATIVEDATA;
  ConfigMiss = AUTHENTICATION_COMPONENT_ERR_MSG.CONFIG_MISS_INDICATIVEDATA;
  ValueMiss = AUTHENTICATION_COMPONENT_ERR_MSG.VALUE_MISS_INDICATIVEDATA;
  proceedWithPinResetMsg = Constants.OTC_MESSAGES.PROCEED_WITH_PIN_RESET_FTU_OTC_MSG;
  fileName: string ="ftu_panel_component";
  ftuMessages = Constants.ftuMessages;

/**
* @author Amarjeet - CCR3-14937
*/
  get ftuValidationGroups(): Array<{ key: string; value: any[] }> {
    const panelData = this.authService.FTUPanelData;
    if (!panelData || typeof panelData !== 'object') {
      return [];
    }

    const groupOrder = ['Name Validation', 'Date Validation', 'Identifier Validation', 'Location Validation'];
    return Object.keys(panelData)
      .filter(key => Array.isArray(panelData[key]))
      .map(key => ({
        key,
        value: panelData[key].map(field => ({ ...field, groupId: field.sectionId }))
      }))
      .sort((firstGroup, secondGroup) => groupOrder.indexOf(firstGroup.key) - groupOrder.indexOf(secondGroup.key));
  }

/**
* @author Amarjeet - CCR3-14937
*/
  get hasGroupWithNoData(): boolean {
    return this.ftuValidationGroups.some(group =>
      group.value.length > 0 && group.value.every(field => {
        const value = field.value 
        const normalizedValue = String(value ?? '').trim();
        return normalizedValue.toUpperCase() === 'NA';
      })
    );
  }

  trackByValidationGroup(index: number, group: { key: string }): string {
    return group.key;
  }

  trackByValidationField(index: number, field: { sectionId: string }): string {
    return field.sectionId;
  }

  constructor(public rootScope: RootScopeService,public aaaSService:AaaSService,    public cusAccService: CustomerAccountBusinessLogicService,
    public authService: AuthMethodService,public genesysService:GenesysCloudService,public logger:LogService) {
    this.authService.getFTUCredential();
    const selected = this.authService.FTUSelectedFields[this.rootScope.activeCustTab.customerSessionId];
    if (selected) {
      this.selectedDateValidation = selected.date;
      this.selectedIdentifierValidation = selected.identifier;
      this.selectedLocationValidation = selected.location;
    }
  }

  
    /**
* Updates the selected language based on the radio button selection.
* This method is triggered whenever the selected radio button changes.
* @param selectedCode - The code of the language selected via the radio button.
* @author Hashid
*/
onRadioChange(selectedCode): void {
  if (selectedCode) {
    this.rootScope.activeCustTab.selectedAlisLang = selectedCode;
  this.logger.infoLogs("Selected Language for FTU: " + selectedCode,this.fileName);
  }
  
}




  /*Validation Functions  */
  
  // public errorHandling(control) {
  //   let value = this.authService.ftuPanelForm?.controls?.[control?.key]?.value;
  //   if (control?.title == "DOB" && this.authService.ftuPanelForm?.controls[control?.key]?.hasError('matDatepickerParse')) {
  //     return 'Invalid date format.';
  //   }
    
  //   else if (control?.title == "HIREDATE" && value && this.authService.ftuPanelForm?.controls[control?.key]?.errors) {//(value?.length == 7 && value?.substring(0, 2) > 12) || 
  //     if (value.length ==8&& allMonths[value.substring(0, 3).toLocaleLowerCase()]) {
  //       let month = allMonths[value.substring(0, 3).toLocaleLowerCase()];
  //       this.authService.ftuPanelForm?.controls?.[control?.key].setValue(month + value.substring(3));

  //       return false;
  //     }
  //    else{ this.authService.ftuPanelForm?.controls[control?.key].setErrors({ pattern: true });
  //     return 'Invalid date format.';
  //   }
  //   }
  //   else if (this.authService.ftuPanelForm?.controls[control?.key]?.errors && value) return "Date of Birth cannot be a future date.";
  //   else return false;
  // }

 /**
   * Resets enabled form controls to their initial values on form cancellation.
   */
 

    /**
   * Checks if there are any FTU data errors and sets the appropriate error message.
   * @returns {boolean} True if there are indicative data errors, false otherwise.
   */
   /* istanbul ignore next */
  showFTUErr() {

    if (this.authService.FTUPanelData?.APIfailure) {
      this.errorMessage = this.ApiFailure;
      return true;
    }

    else if (this.authService.FTUPanelData?.ValueMiss) {
      this.errorMessage = this.ValueMiss;
      return true;
    }

    else if (this.authService.FTUPanelData?.ConfigMiss) {
      this.errorMessage = this.ConfigMiss;
      return true;
    }
    else if (this.authService.FTUPanelData?.validationFailure) {
      this.errorMessage = indicativeMessages.validationFailureMessage;
      return true;
    }

    else{
      this.errorMessage="";
      return false;
    } 
  }

  showValidtionInfo(){
   return(this.authService.FTUPanelData?.APIfailure||this.authService.FTUPanelData?.ValueMiss||this.authService.FTUPanelData?.ConfigMiss); 
  }

  // disableSubmit(){
  //   return (!(this.authService.ftuPanelForm.valid&&this.authService.ftuPanelForm.get('additionalCheckboxKey')?.value==true));
  // }


 /**
 * cancelButton() - moving user to first step.
 * @author Amarjeet
 */
  cancelButton() {
    this.rootScope.activeCustTab.pinEntryApp.step1Active = true;
    this.rootScope.activeCustTab.pinEntryApp.step1Complete = false;
    this.rootScope.activeCustTab.pinEntryApp.step2Active = false;
    this.rootScope.activeCustTab.pinEntryApp.step2Complete = false;
    this.rootScope.activeCustTab.pinEntryApp.pinError = "";
    this.logger.infoLogs("FTU Panel Cancel Button Clicked for customerSessionId:"+this.rootScope.activeCustTab.customerSessionId,this.fileName);
    
  }
 
  /**
 * hasAccountBalance() - checking customer has DB/BC account balance to show/hide message.
 * @author Amarjeet
 */
  hasAccountBalance(): boolean {
    const checkAccBalance_DB_DC = this.rootScope.authConfigUserDataMap[this.rootScope.activeCustTab.customerSessionId];
    return (
      checkAccBalance_DB_DC?.personStatus === Constants.SAuthStatus.ALLOW &&
      checkAccBalance_DB_DC?.voicePinStatus === Constants.SAuthStatus.NOF &&
      checkAccBalance_DB_DC?.voicePinOnFile === false
    );
  }

/**
* @author Amarjeet - CCR3-14937
*/
  selectValidationOnFocus(validationGroup: string, sectionId: string): void {
    const previousSectionId = validationGroup === 'Date Validation' ? this.selectedDateValidation
      : validationGroup === 'Identifier Validation' ? this.selectedIdentifierValidation
      : validationGroup === 'Location Validation' ? this.selectedLocationValidation : '';
    if (previousSectionId && previousSectionId !== sectionId) {
      this.authService.newFTUForm.get(previousSectionId)?.reset('');
    }
    if (validationGroup === 'Date Validation') {
      this.selectedDateValidation = sectionId;
    } else if (validationGroup === 'Identifier Validation') {
      this.selectedIdentifierValidation = sectionId;
    } else if (validationGroup === 'Location Validation') {
      this.selectedLocationValidation = sectionId;
    }
    this.authService.FTUSelectedFields[this.rootScope.activeCustTab.customerSessionId] = {
      date: this.selectedDateValidation,
      identifier: this.selectedIdentifierValidation,
      location: this.selectedLocationValidation
    };
  }

  onValidationChange(validationGroup: string, sectionId: string): void {
    this.selectValidationOnFocus(validationGroup, sectionId);
  }

  isValidationFieldSelected(group: { key: string; value: any[] }, sectionId: string): boolean {
    const confirmedField = group.value.find(field => this.cusAccService.checkIVRConfirmation(field));
    if (confirmedField) {
      return confirmedField.sectionId === sectionId;
    }

    const selectedId = group.key === 'Date Validation' ? this.selectedDateValidation
      : group.key === 'Identifier Validation' ? this.selectedIdentifierValidation : this.selectedLocationValidation;
    return selectedId === sectionId;
  }

  resetNewFTUForm(): void {
    this.authService.createNewFTUForm(this.authService.FTUPanelData);
    this.selectedDateValidation = '';
    this.selectedIdentifierValidation = '';
    this.selectedLocationValidation = '';
    delete this.authService.FTUSelectedFields[this.rootScope.activeCustTab.customerSessionId];
  }

  isPostalAddressField(sectionId: string): boolean {
    return sectionId === this.ftuMessages.SEC_FTU_DATA_PSTL_ADDR;
  }



/**
* @author Amarjeet - CCR3-14937
*/
  isNewFTUFormValid(): boolean {
    const form = this.authService.newFTUForm;
    const groups = this.ftuValidationGroups;
    const isSelectedGroupValid = (groupName: string, selectedId: string): boolean => {
      const group = groups.find(item => item.key === groupName);
      if (group?.value.some(field => this.cusAccService.checkIVRConfirmation(field))) {
        return true;
      }
      const sectionId = selectedId || (group?.value.length === 1 ? group.value[0].sectionId : '');
      const control = form.get(sectionId);
      const value = String(control?.value ?? '').trim();
      return !!group?.value.some(field => field.sectionId === sectionId)
        && !!control && control.enabled && control.valid && !!value && value.toUpperCase() !== 'NA'
        && (!this.isPostalAddressField(sectionId) || form.get('addressVerified')?.value === true);
    };

    const name = String(form.get('SEC-FTU-FNLNAME')?.value ?? '').trim();
    return !!name && name.toUpperCase() !== 'NA' && form.get('nameVerified')?.value === true
      && isSelectedGroupValid('Date Validation', this.selectedDateValidation)
      && isSelectedGroupValid('Identifier Validation', this.selectedIdentifierValidation)
      && isSelectedGroupValid('Location Validation', this.selectedLocationValidation);
  }

}
